import { useMutation } from '@tanstack/react-query';
import Image from 'next/image';
import { useState } from 'react';
import { api } from '../../../lib/axios/axios-client';
import { SideBannerContainer } from '../../containers';
import SideBannerContentContainer from '../../containers/SideBannerContentContainer';
import { RegisterFormSchema } from '../../organisms/RegisterForm/registerform';

import TermsOfService from '../../organisms/TermsOfService';
import RegisterStepOne from './components/step-one';
import {
  ContentInner,
  RegisterPageContainer,
  Title,
  TOSWrapper,
} from './register.styled';

import { useRouter } from 'next/router';

interface RegisterPageProps {
  defaultStep?: number;
}

const RegisterPage = (props: RegisterPageProps) => {
  const router = useRouter();

  const [state, setState] = useState<{
    step: number;
    values: RegisterFormSchema;
  }>({
    step: props.defaultStep ?? 1,
    values: {
      username: '',
      email: '',
      companyName: '',
      firstName: '',
      lastName: '',
      password: '',
      confirmPassword: '',
      salesRep: '',
    },
  });

  const mutation = useMutation({
    mutationFn: (registerInput: Partial<RegisterFormSchema>) =>
      api.post('/auth/register', registerInput),
    onSuccess: async () => {
      // const res = await api.post('/auth/login', {
      //   username: state.values.email,
      //   password: state.values.password,
      // });
      console.log(`success`);

      router.push('/auth/pending-approval');
    },
  });

  return (
    <RegisterPageContainer>
      <SideBannerContentContainer>
        <ContentInner>
          {state.step === 1 ? (
            <RegisterStepOne
              initialValues={state.values}
              onContinue={(values) => setState({ values, step: 2 })}
            />
          ) : null}
          {state.step === 2 ? (
            <TOSWrapper>
              <TermsOfService
                onCancelClick={() => setState({ ...state, step: 1 })}
                onAgreeClick={() => {
                  const { confirmPassword, ...registerInput } = state.values;
                  mutation.mutate(registerInput);
                }}
                disabled={mutation.isLoading || mutation.isSuccess}
              />
              <Image
                style={{ marginTop: 80 }}
                src='https://public.dealerportal.eyeforce.com/images/logo.png'
                width={157}
                height={32}
                alt={'logo'}
              />
            </TOSWrapper>
          ) : null}
        </ContentInner>
      </SideBannerContentContainer>
      <SideBannerContainer
        maxImageWidth={700}
        style={{
          backgroundImage: `url(/assets/images/side-banners/login-banner.png)`,
        }}
      >
        <Title>
          THE FUTURE OF SECURITY
          <br />
          IS ADVANCED
          <br />
          VIDEO MONITORING
        </Title>
      </SideBannerContainer>
    </RegisterPageContainer>
  );
};

export default RegisterPage;
